import React, { memo, useEffect, useRef } from "react";
import {getClass, setDangerousHtml, useDebounce} from "../../../utils";
import styles from "../../Search/ResultsSERP/style.css";
import { clarity } from "react-microsoft-clarity";
import { useStore } from "../../../store";
import Pagination from "../../Pagination";
import YahooAd from "./YahooAd";
import {SPONSORED_ADS_PROVIDER_IDS} from "../../../utils/constants";

const YahooAds = memo(
  ({
    translator,
    data,
    loading,
    searchParams,
    sponsoredSearchResults2Style,
    dublicateResults,
    country,
    clickNotify,
    sponsoredSearchResults2ClientImpressionsURL,
    sendClientEvents,
    reqId,
    URL,
    adsAPI,
    otherParams,
    requestParams,
    overrideOrganicStyles,
    paginationParams,
    articlePage,
    ...props
  }) => {
    const store = useStore(["children", "loadedAds"]);
    const intervalRef = useRef(null);
    const { isSponsoredOnly, paginationEnabled } = paginationParams;
    const { query } = store("search");
    const organicAds = data && data.organic ? data.organic : data.content ? data.content[0]?.value?.items : [];
    const { titleColor, titleFontSize, siteColor, siteFontSize, descriptionColor, descriptionFontSize } = overrideOrganicStyles;
    const beaconUrl = `https://search.yahoo.com/beacon/geop/p?s=1197774733&ysid=${data?.providerSearchId}&traffic_source=${data?.partnerTag}`;

    const submitSearch = useDebounce(
      (val, override) => {
        const v = !val && val !== "" ? query : val;
          if (override?.direction === 'next' && data.providerNextArgs) {
              // Decode pagination args, prevent duplicate decoding..
              const decodedNextArgs = decodeURIComponent(data.providerNextArgs);
              adsAPI.call({
                  ...requestParams,
                  searchTerm: v,
                  nextArgs: encodeURIComponent(decodedNextArgs),
              });
          }
          if (override?.direction === 'prev' && data.providerPrevArgs) {
              // Decode pagination args, prevent duplicate decoding..
              const decodedPrevArgs = decodeURIComponent(data.providerNextArgs);
              adsAPI.call({
                      ...requestParams,
                      searchTerm: v,
                      prevArgs: encodeURIComponent(decodedPrevArgs),
              });
          }
      },
      500,
      [adsAPI.loading]
    );

    useEffect(() => {
      let clarityId, testTraffic;
      store.set("loadedAds", { haveAdsLoaded: true });
      if (store("children").length > 0) {
        store("children").forEach(item => {
          if (item.name === "customComponentV2") {
            const { yahooClarityProjectId, yahooClarityScriptTestTraffic } = item.props.componentConfig;
            clarityId = yahooClarityProjectId;
            testTraffic = yahooClarityScriptTestTraffic;
            clarity.init(clarityId);
          }
        });
      }
      intervalRef.current = setInterval(() => {
        if (window.clarity && window.clarity.v && window.selectTier) {
          window.selectTier.init({
            source_tag: data.partnerTag,
            ysid: data.providerSearchId,
            cid: data.providerClientId,
            ig: data.providerImpressionGuId,
            select_tier: {
              clarityId: clarityId,
              rguid: data.providerRguId
            },
            test_mode: testTraffic === 'true'
          });
          clearInterval(intervalRef.current);
        } else if (!window.clarity && !window.clarity?.v) {
          clarity.init(clarityId);
        }
      }, 300);
      return () => clearInterval(intervalRef.current);
    }, []);

    return (
      <div>
        <section id="sponsoredCtrlId">
            <img height="1" width="1" src={beaconUrl} alt="" hidden />
            {data.ads &&
              data.ads.map((item, index) => {
                const paramsForYahooAd = {
                  item,
                  index,
                  data,
                  clickNotify,
                  loading,
                  extraParams: {
                    clientId: searchParams.clientId,
                    searchTerm: searchParams.searchTerm,
                    serpLayoutVariant: searchParams.serpLayoutVariant,
                    brand: searchParams.brand,
                    dublicateResults,
                  },
                  sponsoredSearchResults2ClientImpressionsURL,
                  sendClientEvents,
                  URL,
                  country,
                  sponsoredSearchResults2Style,
                  reqId,
                  articlePage,
                };

                return (
                  <div key={index}>
                    <YahooAd {...paramsForYahooAd} />
                  </div>
                );
              })}
        </section>

        {organicAds && organicAds.length > 0 && (
          <section id="organicCtrlId" className={styles.organicYahooContainer}>
            <header className={styles.organicYahooHeader}>{translator('Search.Web Results')}</header>
            {organicAds.map((organicAd, key) => (
              <article key={key} className={getClass(styles.genericItem, styles.organicYahooArticle)} data-af-component={props["data-af-component"] || ""} >
                <div>
                  <a
                    ref={setDangerousHtml(organicAd.title)}
                    style={{ color: titleColor || "", fontSize: titleFontSize || "" }}
                    href={organicAd.clickUrl}
                    onClick={clickNotify(props, otherParams)}
                  />
                  <span ref={setDangerousHtml(organicAd.domain)} style={{ color: siteColor || "", fontSize: siteFontSize || "" }} />
                  <div ref={setDangerousHtml(organicAd.description)} style={{ color: descriptionColor || "", fontSize: descriptionFontSize || "" }} />
                </div>
              </article>
            ))}
          </section>
        )}
        {paginationEnabled && isSponsoredOnly ? (
          <Pagination
            enablePrevPage={data?.providerPrevArgs}
            submitSearch={(p, direction) => {submitSearch(false, {p, direction})}}
            provider={SPONSORED_ADS_PROVIDER_IDS.YAHOO_SYNDICATION.id}
          />
        ) : null}
      </div>
    );
  }
);

export default YahooAds;
